import { atom } from 'jotai';
import { Topic } from 'shared/models';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export interface IArticleRelatedHashtag {
  items: Topic[];
  sugWords: string[];
  gptExtendWords: {
    highVolumeWords: string[];
    longTailWords: string[];
    relatedSEOWords: string[];
  };
}

type TArticleRelatedHashtagStore = {
  [key: string]: Promise<IArticleRelatedHashtag> | IArticleRelatedHashtag | undefined;
};

const $ArticleRelatedHashtagStore = atom<TArticleRelatedHashtagStore>({});

export const $ArticleRelatedHashtag = safeAtomFamily((groupId: string) => {
  const a = atom(
    (get) => {
      const data = get($ArticleRelatedHashtagStore)[groupId];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, input: IArticleRelatedHashtag | Promise<IArticleRelatedHashtag>) => {
      const old = get($ArticleRelatedHashtagStore);
      set($ArticleRelatedHashtagStore, {
        ...old,
        [groupId]: input,
      });
    },
  );

  a.debugLabel = `$ArticleRelatedHashtag+${encodeURIComponent(groupId)}`;

  return a;
});
